import React, { useState } from 'react';
import { X as XIcon, Check as CheckIcon, ChevronDown as ChevronDownIcon } from 'lucide-react';
interface AdvancedFiltersProps {
  isOpen: boolean;
  onClose: () => void;
  onApplyFilters: (filters: any) => void;
}
export const AdvancedFilters: React.FC<AdvancedFiltersProps> = ({
  isOpen,
  onClose,
  onApplyFilters
}) => {
  const [engagementType, setEngagementType] = useState<string[]>([]);
  const [relevanceLevel, setRelevanceLevel] = useState<string[]>([]);
  const [dateRange, setDateRange] = useState<string>('all');
  const [companySize, setCompanySize] = useState<string[]>([]);
  const [industry, setIndustry] = useState<string[]>([]);
  const handleToggleEngagementType = (type: string) => {
    setEngagementType(prev => prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]);
  };
  const handleToggleRelevanceLevel = (level: string) => {
    setRelevanceLevel(prev => prev.includes(level) ? prev.filter(l => l !== level) : [...prev, level]);
  };
  const handleToggleCompanySize = (size: string) => {
    setCompanySize(prev => prev.includes(size) ? prev.filter(s => s !== size) : [...prev, size]);
  };
  const handleToggleIndustry = (ind: string) => {
    setIndustry(prev => prev.includes(ind) ? prev.filter(i => i !== ind) : [...prev, ind]);
  };
  const handleApply = () => {
    onApplyFilters({
      engagementType,
      relevanceLevel,
      dateRange,
      companySize,
      industry
    });
    onClose();
  };
  const handleReset = () => {
    setEngagementType([]);
    setRelevanceLevel([]);
    setDateRange('all');
    setCompanySize([]);
    setIndustry([]);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-end sm:items-center justify-center p-4" data-id="element-6">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-hidden" data-id="element-7">
        <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-8">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-9">
            Advanced Filters
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-10">
            <XIcon size={20} data-id="element-11" />
          </button>
        </div>
        <div className="p-4 overflow-y-auto max-h-[60vh]" data-id="element-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-13">
            <div data-id="element-14">
              <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-15">
                Engagement Type
              </h4>
              <div className="space-y-2" data-id="element-16">
                {['liked', 'commented', 'shared', 'multiple'].map(type => <label key={type} className="flex items-center" data-id="element-17">
                    <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={engagementType.includes(type)} onChange={() => handleToggleEngagementType(type)} data-id="element-18" />
                    <span className="ml-2 text-sm text-gray-700 capitalize" data-id="element-19">
                      {type}
                    </span>
                  </label>)}
              </div>
              <h4 className="text-sm font-medium text-gray-700 mt-6 mb-2" data-id="element-20">
                Relevance Level
              </h4>
              <div className="space-y-2" data-id="element-21">
                {['high', 'medium', 'low'].map(level => <label key={level} className="flex items-center" data-id="element-22">
                    <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={relevanceLevel.includes(level)} onChange={() => handleToggleRelevanceLevel(level)} data-id="element-23" />
                    <span className="ml-2 text-sm text-gray-700 capitalize" data-id="element-24">
                      {level}
                    </span>
                  </label>)}
              </div>
              <h4 className="text-sm font-medium text-gray-700 mt-6 mb-2" data-id="element-25">
                Date Range
              </h4>
              <div className="space-y-2" data-id="element-26">
                <select value={dateRange} onChange={e => setDateRange(e.target.value)} className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-27">
                  <option value="all" data-id="element-28">All time</option>
                  <option value="today" data-id="element-29">Today</option>
                  <option value="yesterday" data-id="element-30">Yesterday</option>
                  <option value="week" data-id="element-31">Last 7 days</option>
                  <option value="month" data-id="element-32">Last 30 days</option>
                  <option value="quarter" data-id="element-33">Last 90 days</option>
                </select>
              </div>
            </div>
            <div data-id="element-34">
              <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-35">
                Company Size
              </h4>
              <div className="space-y-2" data-id="element-36">
                {['1-10', '11-50', '51-200', '201-1000', '1001+'].map(size => <label key={size} className="flex items-center" data-id="element-37">
                      <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={companySize.includes(size)} onChange={() => handleToggleCompanySize(size)} data-id="element-38" />
                      <span className="ml-2 text-sm text-gray-700" data-id="element-39">
                        {size} employees
                      </span>
                    </label>)}
              </div>
              <h4 className="text-sm font-medium text-gray-700 mt-6 mb-2" data-id="element-40">
                Industry
              </h4>
              <div className="space-y-2" data-id="element-41">
                {['Technology', 'Marketing', 'Finance', 'Healthcare', 'Education', 'Retail'].map(ind => <label key={ind} className="flex items-center" data-id="element-42">
                    <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={industry.includes(ind)} onChange={() => handleToggleIndustry(ind)} data-id="element-43" />
                    <span className="ml-2 text-sm text-gray-700" data-id="element-44">{ind}</span>
                  </label>)}
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-between" data-id="element-45">
          <button onClick={handleReset} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-46">
            Reset All
          </button>
          <div className="space-x-3" data-id="element-47">
            <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-48">
              Cancel
            </button>
            <button onClick={handleApply} className="px-4 py-2 bg-[#f9b30f] hover:bg-[#e0a40e] rounded-md text-sm font-medium text-white" data-id="element-49">
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </div>;
};